import { render, staticRenderFns } from "./EstablishmentRolesTable.vue?vue&type=template&id=00d32ef3&"
import script from "./EstablishmentRolesTable.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRolesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports